module.exports = __webpack_public_path__ + "static/media/search--light.10350d2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/search--light.svg
// module id = 502
// module chunks = 0